import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Cookies from 'universal-cookie';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import ReactModal from 'react-modal';
import { DefaultLists, CustomLists, DeleteAddressModal, SnackBar } from '@desquared/wave-components-library';
import { ResponsiveMenuStore } from '@/store/sideSheet';
import { createUserLists, deleteUserList, editUserList } from '@/api/lists';
import { updateUserGetLists } from '@/utils/getLists';
import UserListsStore from '@/store/userLists';
import CUSTOM_STYLES from '@/utils/modalStyle';
import { getProductImage } from '@/utils/products';
import SmartList from '../../../public/assets/wave-grocery/SmartList.png';
import Link from 'next/link';

import styles from '@/styles/User.module.css';
import { useTranslations } from 'next-intl';
export default function UserLists({ user, favouritesImage, suggestedImage }) {
  const [serverLists, setServerLists] = useState([]);
  const [cardsLists, setCardsLists] = useState([]);
  const [editName, setEditName] = useState('');
  const [deletedList, setDeletedList] = useState(null);
  const [isDeleteModalIOpen, setIsDeleteModalIOpen] = useState(false);
  const [showSnackBar, setShowSnackbar] = useState(false);
  const [snackText, setSnackText] = useState('');
  const [selectedId, setSelectedId] = useState();
  const [favouriteId, setFavouriteId] = useState();
  const [suggestedId, setSuggestedId] = useState();
  const [suggestedLength, setSuggestedLength] = useState(0);
  const [reverseDelete, setReverseDelete] = useState();
  let finalReverseDelete = false;
  const router = useRouter();
  const cookies = new Cookies();
  const authorization = cookies.get('token');
  const openMenu = () => {
    ResponsiveMenuStore.open();
  };

  const t = useTranslations('user_lists');
  const r = useTranslations('user_history');

  useEffect(() => {
    async function getNewLists(token) {
      const lists = await updateUserGetLists(token);
      setServerLists(lists);
      const cards = createCardsLists(lists);
      setCardsLists(cards);
      return;
    }
    if (!isEmpty(authorization)) getNewLists(authorization);
  }, [router.locale]);

  useEffect(() => {
    if (deletedList) {
      setTimeout(() => {
        if (!reverseDelete && !finalReverseDelete) {
          setShowSnackbar(false);
          finalDelete(deletedList._id);
        }
      }, 5000);
    }
  }, [reverseDelete]);

  const create = async () => {
    if (!user?._id) {
      router.push(`/`);
    }
    let newServerLists = cloneDeep(serverLists);

    const { data, error } = await createUserLists(editName, user.token);
    if (error) {
      setSnackText('Η λίστα υπάρχει ήδη!');
      setShowSnackbar(true);
    } else {
      newServerLists.splice(0, 0, data);
      setServerLists(newServerLists);
      UserListsStore.update(newServerLists);
      const cards = createCardsLists(newServerLists);
      setEditName('');
      setCardsLists(cards);
    }
  };

  const editUserListName = async listId => {
    const { data, error } = await editUserList(user.authToken, listId, editName, router.locale);
    let newServerLists = cloneDeep(serverLists);

    if (error) {
      //addERROR
    } else {
      let changesLists = newServerLists.find((list, index) => {
        if (list._id === listId) {
          newServerLists[index].label = editName;
          return;
        }
      });
      UserListsStore.update(newServerLists);
      setServerLists(newServerLists);
      const cards = createCardsLists(newServerLists);
      setEditName('');
      setCardsLists(cards);
    }
  };

  const deleteList = listId => {
    let newServerLists = cloneDeep(serverLists);
    const deletedList = newServerLists.find(list => list._id === listId);
    setDeletedList(deletedList);
    newServerLists = newServerLists.filter(list => {
      return list._id != listId;
    });
    UserListsStore.update(newServerLists);
    setServerLists(newServerLists);
    const cards = createCardsLists(newServerLists);
    setCardsLists(cards);
  };

  const finalDelete = async listId => {
    if (!reverseDelete) {
      const { data, error } = await deleteUserList(user.authToken, listId);
      let newServerLists = cloneDeep(serverLists);
    }
  };

  const revertList = () => {
    if (deletedList) {
      finalReverseDelete = true;
      setReverseDelete(true);
      const newServerLists = [...serverLists, deletedList];
      UserListsStore.update(newServerLists);
      setServerLists(newServerLists);
      const cards = createCardsLists(newServerLists);
      setCardsLists(cards);
      setDeletedList(null);
    }
    setShowSnackbar(false);
  };

  const createCardsLists = lists => {
    const newCardsList = [
      {
        type: 'new',
        title: t('new_card.title'),
        cancelWording: t('new_card.cancel'),
        onPrimaryClick: create,
        onCancel: () => {},
        primaryButtonWording: t('new_card.save'),
        listPlaceHolder: t('new_card.list_placeholder'),
        listLabel: t('new_card.list_label'),
        index: 0,
        addText: t('add_products'),
      },
    ];
    const remainingList1 = lists.filter(list => {
      if (list.type === 'favorites') setFavouriteId(list._id);
      if (list.type === 'suggested') {
        setSuggestedId(list._id);
        setSuggestedLength(list?.numberOfListProducts > 0);
      }
      return list.type !== 'favorites' && list.type !== 'suggested';
    });
    const remainingList = remainingList1.map((list, index) => {
      return {
        type: 'filled',
        title: list.label,
        cancelWording: t('new_card.cancel'),
        onPrimaryClick: () => editUserListName(list._id),
        onCancel: () => editUserListName(list._id),
        primaryButtonWording: t('new_card.save'),
        listPlaceHolder: t('new_card.list_placeholder'),
        listLabel: t('new_card.list_label'),
        index: index + 1,
        amount: list.products.length,
        supportiveText: t('new_card.supportive_text', { count: list.products.length }),
        imagesList: createImageList(list.productsPreview),
        id: list._id,
        addlink: '/categories/',
        link: list.products.length === 0 ? '' : `/user/lists/list/?id=${list._id}`,
        addText: t('add_products'),
      };
    });
    return [...newCardsList, ...remainingList];
  };

  const onListClick = id => {
    router.push(`/user/lists/list/?id=${id}`);
  };

  const createImageList = previewList => {
    let imageList = [];
    if (previewList && previewList.length > 0) {
      const newImage = previewList.map(item => {
        let image = getProductImage(item, '1x');
        imageList.push({ image: image, imageAlt: item.name });
      });
    }
    return imageList;
  };

  const onEditNameChange = e => {
    setEditName(e.currentTarget.value);
  };

  return (
    <>
      <div className={styles.listContainer}>
        <DefaultLists
          hasSuggested={suggestedId && suggestedLength > 0}
          favouritesLink={`/user/lists/list/?id=${favouriteId}`}
          suggestedLink={`/user/lists/list/?id=${suggestedId}`}
          favouritesTitle={t('favourites')}
          favouritesText={t('favourites_text')}
          suggestedTitle={t('suggested')}
          suggestedText={t('suggested_text')}
          suggestedImag={SmartList}
          title={t('title')}
          onBack={() => {
            openMenu();
          }}
          LinkComponent={Link}
          favouritesImage={favouritesImage}
          suggestedImage={suggestedImage}
        />
        <div className={styles.customContainer}>
          <CustomLists
            title={t('custom_lists')}
            cardsList={cardsLists}
            listName={editName}
            setListName={onEditNameChange}
            editListName={editUserListName}
            createNewList={create}
            deleteList={id => {
              setIsDeleteModalIOpen(true);
              setSelectedId(id);
            }}
            handleClick={id => onListClick(id)}
            setNewListName={setEditName}
            customListsAriaLabels={{
              editAriaLabel: r('edit.cta'),
              deleteAriaLabel: t('delete_modal.delete'),
            }}
          />
        </div>
      </div>

      {isDeleteModalIOpen && (
        <ReactModal
          isOpen={isDeleteModalIOpen}
          onRequestClose={() => {
            setIsDeleteModalIOpen(false);
          }}
          style={CUSTOM_STYLES}
          contentLabel={'delete modal'}
          ariaHideApp={false}
          className={cn(styles.modalContainer, styles.modal)}
          shouldCloseOnOverlayClick={true}
        >
          <DeleteAddressModal
            title={t('delete_modal.title')}
            description={t('delete_modal.description')}
            cancelWording={t('delete_modal.cancel')}
            onDelete={() => {
              deleteList(selectedId);
              setIsDeleteModalIOpen(false);
              setShowSnackbar(true);
              setReverseDelete(false);

              setSnackText(t('delete_modal.success_text'));
            }}
            onCancel={() => {
              setIsDeleteModalIOpen(false);
            }}
            deleteWording={t('delete_modal.delete')}
          />
        </ReactModal>
      )}
      <SnackBar
        open={showSnackBar}
        setOpen={() => {
          setShowSnackbar(false);
          if (deletedList && snackText !== t('delete_modal.success_text')) finalDelete(selectedId);
        }}
        hasCloseOption={true}
        buttonText={snackText === t('delete_modal.success_text') ? t('delete_modal.restore_button') : undefined}
        onButtonPress={revertList}
        text={snackText}
        position={'center'}
      />
    </>
  );
}
